export const apiEndpoints = {
    PASSWORD_CODE_GENERATE: '/authenticate/password/code/generate',
    PASSWORD_CODE_VERIFY: '/authenticate/password/code/verify',
    PASSWORD_CHANGE: '/authenticate/password/change',
    PASSWORD_CANCEL_CHANGE: '/authenticate/password/cancel',
    AUTHENTICATION_METHOD: '/authenticate/method/{username}',
    AUTHENTICATE: '/authenticate/login',
    EXCHANGE_TOKEN: '/authenticate/exchange/{tokenType}',
    NEW_ACCESS_TOKEN: '/applications/{application}/new-token',
    REFRESH_ACCESS_TOKEN: '/applications/{application}/refresh-token',
    LOGOUT: '/authenticate/logout',
    APPLICATIONS: '/applications',
};